module.exports = __webpack_public_path__ + "media/images/icons/filled/frown-095b3fed9ac905425a5deeff229db38b.svg";